<div class="loader" *ngIf="globals.isLoading">
  <span class="loader-animation"></span>
</div>

<app-header *ngIf="globals.isLoggedIn"></app-header>
<app-registry-header
  *ngIf="
    !globals.isLoggedIn &&
    (isCredentialRegistryPage() || isSignUpTandCPage() || isStorePublic())
  "
></app-registry-header>
<div
  id="container"
  class="overflow-hidden"
  [ngClass]="{
    inner_content_block:
      globals.isLoggedIn || isCredentialRegistryPage() || isSignUpTandCPage() || isStorePublic(),
    without_login_content:
      !globals.isLoggedIn &&
      (isCredentialRegistryPage() || isSignUpTandCPage() || isStorePublic()),
  }"
>
  <router-outlet></router-outlet>
</div>
<app-footer
  *ngIf="
    globals.isLoggedIn ||
    isCredentialRegistryPage() ||
    isSignUpTandCPage() ||
    isStorePublic()
  "
></app-footer>
